import React from 'react';
import { SvgIcon } from '@mui/material';

export default function GptIcon({
  strokeColor = '#4520AB',
  fillColor = '#FFBC5B',
  ...props
}) {
  return (
    <SvgIcon viewBox="0 0 24 24" sx={{ width: 24, height: 24 }} {...props}>
      <g clip-path="url(#clip0_16466_62585)">
        <rect width="24" height="24" rx="8" fill={fillColor} />
        <path
          d="M11.7732 14.5339L7.4707 12.0004V7.55573C7.4707 5.59119 9.09305 4 11.0941 4C12.336 4 13.432 4.61336 14.0854 5.54763"
          stroke={strokeColor}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.86719 18.383C10.2013 18.8824 10.6537 19.2914 11.1842 19.5737C11.7146 19.856 12.3066 20.0027 12.9074 20.0009C14.9076 20.0009 16.5308 18.4097 16.5308 16.4452V12.0005L12.1429 9.41992"
          stroke={strokeColor}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.73438 13.3333V8.15086L13.6564 5.92853C15.3899 4.94626 17.6061 5.52851 18.607 7.22904C18.9136 7.74746 19.0809 8.33632 19.0927 8.93846C19.1046 9.54061 18.9605 10.1356 18.6746 10.6657"
          stroke={strokeColor}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.32352 13.3338C5.03746 13.8638 4.89327 14.4587 4.90495 15.0609C4.91664 15.663 5.08379 16.2519 5.39019 16.7704C6.39116 18.4709 8.60821 19.0532 10.3417 18.0718L14.2637 15.8495L14.3491 10.875"
          stroke={strokeColor}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5299 17.0042C17.1358 16.9807 17.7262 16.8061 18.2474 16.4962C18.7687 16.1863 19.2041 15.751 19.5141 15.2299C20.5142 13.5293 19.9203 11.3541 18.1878 10.3727L14.2648 8.15039L9.76758 10.5994"
          stroke={strokeColor}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.47141 6.99609C6.86533 7.01939 6.2747 7.19394 5.75332 7.50384C5.23194 7.81374 4.79638 8.24914 4.4863 8.7704C3.48533 10.4709 4.07915 12.6462 5.81262 13.6275L9.73558 15.8499L14.223 13.4053"
          stroke={strokeColor}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16466_62585">
          <rect width="24" height="24" rx="8" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
